"use client";

import { useState } from "react";
import { ChevronDown } from "lucide-react";

const faqs = [
  {
    question: "How do I choose the right generator size?",
    answer:
      "Choose a generator based on the total equipment load you need to operate, including the starting or surge requirements of equipment such as pumps and motors. If you are unsure of your requirements, seek professional guidance before purchasing.",
  },
  {
    question: "What can I power with a generator?",
    answer:
      "A generator can power different appliances, machines and electrical systems depending on its capacity and the requirements of the equipment connected to it. The total running load and starting requirements should be considered before selecting a generator.",
  },
  {
    question: "How often should a generator be serviced?",
    answer:
      "Generator servicing should follow the manufacturer's recommended maintenance schedule. Usage, operating conditions and the type of generator can affect how frequently maintenance is required.",
  },
  {
    question: "Does Mobetts supply generator spare parts?",
    answer:
      "Yes. Mobetts supplies genuine spare parts for equipment and can assist customers in identifying appropriate replacement components for their generators and other equipment.",
  },
];

export default function GeneratorFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <div className="w-full py-16 lg:py-24 px-4">
      <div className="text-center mb-12 lg:mb-16">
        <h2 className="lg:text-4xl text-2xl font-bold text-primary">
          Frequently Asked Questions
        </h2>
      </div>

      <div className="max-w-3xl mx-auto flex flex-col gap-3 lg:gap-4">
        {faqs.map((faq, index) => {
          const isOpen = openIndex === index;

          return (
            <div
              key={faq.question}
              className="border border-gray-200 rounded-lg overflow-hidden bg-white"
            >
              <button
                type="button"
                onClick={() => toggle(index)}
                aria-expanded={isOpen}
                className="w-full flex items-center justify-between gap-4 text-left p-5 lg:p-6"
              >
                <span className="lg:text-lg font-bold text-primary">
                  {faq.question}
                </span>
                <ChevronDown
                  className={`w-5 h-5 flex-shrink-0 text-primary transition-transform duration-200 ${
                    isOpen ? "rotate-180" : ""
                  }`}
                />
              </button>
              <div
                className={`grid transition-all duration-200 ease-in-out ${
                  isOpen
                    ? "grid-rows-[1fr] opacity-100"
                    : "grid-rows-[0fr] opacity-0"
                }`}
              >
                <div className="overflow-hidden">
                  <p className="text-sm lg:text-base text-gray-600 px-5 lg:px-6 pb-5 lg:pb-6">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}